import Vue from 'vue'
import Vuex from 'vuex'
import '@/assets/js/common/Language.js'

Vue.use(Vuex)

let selectLang = 0;
//本地存储中没有先获取浏览器的语言
if(localStorage.getItem("selectLanguage") == null)
{
    //获取本地语言
    const lang = navigator.language;
    const localLang = lang.substr(0, 2);//截取lang前2位字符
    console.log(localLang)
    if(localLang != 'zh')
    {
        selectLang = 1;
    }
    localStorage.setItem("selectLanguage", selectLang);
}
else {
    selectLang = localStorage.getItem("selectLanguage");
}
const state = {
    projectName: null,
    projectId: null,
    memberToken:null,
    memberName:null,
    memberHeadImage:null,
    enterPageUrl:null,
    i18n:global.CN_EN,
    CN_EN: selectLang,//0为中文，1为英文
}
const mutations = {
    setProjectName(state, num){
        state.projectName = num
    },
    setProjectId(state, num){
        state.projectId = num
    },
    setMemberToken(state, num){
        state.memberToken = num
    },
    setMemberName(state, num){
        state.memberName = num
    },
    setMemberHeadImage(state, num){
        state.memberHeadImage = num
    },
    setEnterPageUrl(state, num){
        state.enterPageUrl = num
    },
    setLanguage(state, num){
        state.CN_EN = num
    }
}
export default  new Vuex.Store({
    state, mutations
})
